import { type DayCloseState } from "./state";

export const initialState: DayCloseState = {
  isSubmitting: false,
  submitError: "",
  closed: false,
};
